module.exports = __webpack_public_path__ + "static/img/regbg.96e3514.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/regbg.png
// module id = BJon
// module chunks = 1